import { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useSelector } from 'react-redux';
import { RootState } from '../../../redux';

const AuthenticatedGuard = ({ children } : PropsWithChildren<any>) => {
  
  const loggedIn = useSelector((state: RootState) => state.auth.loggedIn);

  const location = useLocation();
  const redirectRoute = '/login';
  
  return <>
  {loggedIn ? 
    children : 
    <Navigate to={redirectRoute} state={{ from: location.pathname }} />}
  </>

}


export default AuthenticatedGuard;
